import { USER_TYPE, USER_TYPE_SEARCH_PARAM } from 'constant/qrcode';
import { useAppNavigation } from 'hooks/common/useAppNavigation';

export const BASE_QR_PATH = '/qr';

export const useQRPageNavigation = () => {
  const { navigateTo } = useAppNavigation();

  return {
    goToVerifyIdentity: () => navigateTo(`${BASE_QR_PATH}/verify-identity`),
    goToVerifyCode: () => navigateTo(`${BASE_QR_PATH}/verify-code`),
    goToAddNewGuestUser: () => navigateTo(`${BASE_QR_PATH}/add-new-guest-user`),
    goToNewGuestUserDetail: () =>
      navigateTo(
        `${BASE_QR_PATH}/user-detail?${USER_TYPE_SEARCH_PARAM}=${USER_TYPE.NEW_GUEST}`,
      ),
    goToRegisteredGuestUserDetail: () =>
      navigateTo(
        `${BASE_QR_PATH}/user-detail?${USER_TYPE_SEARCH_PARAM}=${USER_TYPE.GUEST}`,
      ),
    goToVariconUserDetail: () =>
      navigateTo(
        `${BASE_QR_PATH}/user-detail?${USER_TYPE_SEARCH_PARAM}=${USER_TYPE.VARICON_USER}`,
      ),
    goToVariconEmployeeDetail: () =>
      navigateTo(`${BASE_QR_PATH}/varicon-employee-detail`),
    goToEquipmentDetailsPage: (equipmentId: string) =>
      navigateTo(`${BASE_QR_PATH}/equipment-details/${equipmentId}`, {
        replace: true,
      }),
    goToLoginPage: () => navigateTo('/login', { replace: true }),
  };
};
